const employeeRoute = {
    BASE_PATH: "/employees",
    detailPath: function(id: string | number) {
        return `${this.BASE_PATH}/${id}`
    },
    kpiDetailPath: function(id: string | number) {
        return `${this.BASE_PATH}/${id}/kpi`
    }
}

export default employeeRoute;